export class Login {
  email: string;
  senha: string;
  desafio: string | null;
}

export class ResetarSenha {
  novaSenha: string;
  confirmaSenha: string;
}
